import LanguageButton from 'components/gruenland/atoms/localization/LanguageButton';
import LanguageCurrent from 'components/gruenland/atoms/localization/LanguageCurrent';
import { LANGUAGE_CODES } from 'project.config';

type Props = {
  currentLanguage: string;
  onSelectLanguage: (language: string) => void;
};
const LanguagePicker: React.FC<Props> = ({ currentLanguage, onSelectLanguage }) => {
  return (
    <div className="flex gap-3">
      {LANGUAGE_CODES.map((l) =>
        currentLanguage?.slice(0, 2) === l ? (
          <LanguageCurrent key={l} language={l} />
        ) : (
          <LanguageButton key={l} language={l} onClick={() => onSelectLanguage(l)} />
        ),
      )}
    </div>
  );
};

export default LanguagePicker;
